import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Container,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  InputBase,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import CloseIcon from '@mui/icons-material/Close';
import { BsEmojiSmile, BsPatchCheck } from 'react-icons/bs';
import { Link, useNavigate } from 'react-router-dom';

import { CommonApiforJourney } from './services/JourneyApi';
import ApiErrorMessage from './Global/ApiErrorMessage';

import partnerService from './services/partnerService';

const { PartnerSignup } = partnerService;

function SignUpNew() {
  const navigate = useNavigate();
  const [selectGender, setSelectGender] = useState(' ');
  const [selectBestDescribes, setSelectBestDescribes] = useState(' ');
  const [thankYouMsg, setThankYouMsg] = useState(false);

  const [partnerSignupResponse, setPartnerSignupResponse] = useState('');
  const [loaderBoxNew, setLoaderBoxNew] = useState(false);
  const [openApiError, setOpenApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [signUpState, setSignUpState] = useState({
    firstName: null,
    lastName: null,
    email: null,
    mobileNo: null,
    genderList: [],
    genderName: ' ',
    age: null,
    cityList: [],
    cityId: null,
    stateList: [],
    stateId: null,
    describe: ' ',
    describeList: []
  });

  // console.log('signUpState', signUpState);
  useEffect(() => {
    let cancel = false;
    const PartnerSignupAPi = async () => {
      const PartnerSignupResponse = await PartnerSignup({
        password: '',
        username: ''
      });
      if (PartnerSignupResponse.status === 'OK') {
        if (cancel) return;
        setPartnerSignupResponse(PartnerSignupResponse.jwt);
        localStorage.setItem(
          'guestUser',
          JSON.stringify({
            isLogedIn: true,
            token: PartnerSignupResponse.jwt
          })
        );
      }
    };
    PartnerSignupAPi();
    loantyprapiFire('stateList', '');
    loantyprapiFire('genderList', 'get');
    loantyprapiFire('description', 'get');

    return () => {
      cancel = true;
    };
  }, []);

  useEffect(() => {}, [signUpState.stateList]);

  const loantyprapiFire = async (type, condition) => {
    const prevSavedData = JSON.parse(localStorage.getItem('guestUser'));
    const companyIdObj = {};
    let methodName = '';
    let endapiPath = '';
    let genderType = '';
    let schema = '';
    let descriptionType = '';

    const token = prevSavedData.token;

    if (type === 'stateList') {
      companyIdObj.searchLiteral = '';
      companyIdObj.countryId = 101;
      methodName = 'POST';
      endapiPath = 'sa/cscs/state/list';
    } else if (type === 'cityList') {
      companyIdObj.searchLiteral = '';
      companyIdObj.stateId = condition;
      methodName = 'POST';
      endapiPath = 'sa/cscs/city/list';
    } else if (type === 'genderList') {
      genderType = 'gender-type';
      schema = 'los_partner';
      methodName = 'GET';
      endapiPath = `common/master-list/${genderType}/${schema}`;
    } else if (type === 'description') {
      descriptionType = 'SIGNUP_DESCRIBE_OPTION_TYPE';
      methodName = 'GET';
      endapiPath = `master/${descriptionType}`;
    } else if (type === 'submit') {
      const pattern = /^[6-9][0-9]{9}$/;
      const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

      if (signUpState.firstName === null) {
        setOpenApiError(true);
        setErrorMessage('Please enter first name');
        return;
      }
      if (signUpState.lastName === null) {
        setOpenApiError(true);
        setErrorMessage('Please enter last name');
        return;
      }
      if (!mailformat.test(signUpState.email)) {
        setOpenApiError(true);
        setErrorMessage('Please enter vaild email address');
        return;
      }
      if (!pattern.test(signUpState.mobileNo)) {
        setOpenApiError(true);
        setErrorMessage('Please enter valid mobile number');
        return;
      }
      if (signUpState.genderName === ' ') {
        setOpenApiError(true);
        setErrorMessage('Please select gender');
        return;
      }
      if (signUpState.age === null) {
        setOpenApiError(true);
        setErrorMessage('Please enter age');
        return;
      }
      if (signUpState.stateId === null) {
        setOpenApiError(true);
        setErrorMessage('Please select state');
        return;
      }
      if (signUpState.cityId === null) {
        setOpenApiError(true);
        setErrorMessage('Please select city');
        return;
      }
      if (signUpState.describe === ' ') {
        setOpenApiError(true);
        setErrorMessage('Please select description');
        return;
      }

      companyIdObj.age = signUpState.age;
      companyIdObj.cityId = signUpState.cityId.cityId;
      companyIdObj.describeYouTypeId = signUpState.describe;
      companyIdObj.describeYouUserInput = '';
      companyIdObj.email = signUpState.email;
      companyIdObj.firstName = signUpState.firstName;
      companyIdObj.genderTypeId = signUpState.genderName;
      companyIdObj.lastName = signUpState.lastName;
      companyIdObj.mobileNumber = signUpState.mobileNo;
      companyIdObj.stateId = signUpState.stateId.stateId;

      methodName = 'POST';
      endapiPath = 'onboard/signup-new';
    }

    // loanTypebycompany(
    //   type,
    //   methodName,
    //   endapiPath,
    //   JSON.stringify(companyIdObj),
    //   token,
    //   '',
    //   condition
    // );

    if (condition === 'get') {
      loanTypebycompany(type, methodName, endapiPath, '', token, '', '');
    } else {
      loanTypebycompany(
        type,
        methodName,
        endapiPath,
        JSON.stringify(companyIdObj),
        token,
        '',
        condition
      );
    }
  };

  const loanTypebycompany = async (
    type,
    method,
    endpoint,
    credentials,
    authToken,
    frmData,
    condition
  ) => {
    setLoaderBoxNew(true);
    const responseData = await CommonApiforJourney(
      method,
      endpoint,
      credentials,
      authToken,
      frmData
    );
    if (responseData.status === 'success' || responseData.action_status === 'success') {
      setLoaderBoxNew(false);
      if (type === 'stateList') {
        const prevState = signUpState;
        prevState.stateList = responseData.data;
        setSignUpState({ ...prevState });
      } else if (type === 'cityList') {
        const prevState = signUpState;
        prevState.cityList = responseData.data;
        setSignUpState({ ...prevState });
      } else if (type === 'genderList') {
        const prevState = signUpState;
        prevState.genderList = responseData.data.masterTypes;
        setSignUpState({ ...prevState });
      } else if (type === 'description') {
        const prevState = signUpState;
        prevState.describeList = responseData.data.SignupDescribeOptionType;
        setSignUpState({ ...prevState });
      } else if (type === 'submit') {
        setThankYouMsg(true);
      }
    } else if (responseData.status === 'error') {
      setLoaderBoxNew(false);
      setOpenApiError(true);
      setErrorMessage('Something went wrong !');
    } else {
      setLoaderBoxNew(false);
      setOpenApiError(true);
      setErrorMessage('Something went wrong !');
    }
  };

  // console.log('responseAPIDATE', signUpState);

  return (
    <Box className="LoginOuter" sx={{ width: '100%', height: '100vh' }}>
      <Container maxWidth="lg">
        <Box pt={3} pb={3} mb={4} sx={{ position: 'relative' }}>
          <Stack>
            <Box className="textAlignCenter">
              <Box mb={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                <img
                  src="../../static/logos/realValueLogo.jpg"
                  alt="Real Value Logo"
                  style={{ height: '80px' }}
                />
              </Box>
              <Typography variant="h5" className="colorBlue" mb={1}>
                Thank you for the overwhelming response to our Early Access Program!
              </Typography>
              <Typography variant="subtitle1" className="colorBlue" mb={3}>
                We are working double time to clear the backlog of applications and will be taking
                on board new partners soon!
              </Typography>
              <Typography variant="subtitle2" className="" mb={5}>
                To join the waitlist please drop in your details in the form below
              </Typography>
            </Box>
          </Stack>
          <Grid container spacing={3} mb={3}>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2" className="formLabel">
                First Name<span className="colorRed">*</span>
              </Typography>
              <TextField
                fullWidth
                inputProps={{ className: 'textInput' }}
                value={signUpState.firstName}
                onChange={(e) => {
                  const prevState = signUpState;
                  prevState.firstName = e.target.value;
                  setSignUpState({ ...prevState });
                }}
                placeholder="Type First Name"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2" className="formLabel">
                Last Name<span className="colorRed">*</span>
              </Typography>
              <TextField
                fullWidth
                inputProps={{ className: 'textInput' }}
                placeholder="Type Last Name"
                value={signUpState.lastName}
                onChange={(e) => {
                  const prevState = signUpState;
                  prevState.lastName = e.target.value;
                  setSignUpState({ ...prevState });
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2" className="formLabel">
                Email id<span className="colorRed">*</span>
              </Typography>
              <TextField
                fullWidth
                inputProps={{ className: 'textInput' }}
                placeholder="Type Email id"
                type="email"
                value={signUpState.email}
                onChange={(e) => {
                  const prevState = signUpState;
                  prevState.email = e.target.value;
                  setSignUpState({ ...prevState });
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2" className="formLabel">
                Mobile Number<span className="colorRed">*</span>
              </Typography>
              <TextField
                fullWidth
                inputProps={{ className: 'textInput' }}
                placeholder="Type Mobile Number"
                type="number"
                value={signUpState.mobileNo}
                onChange={(e) => {
                  const prevState = signUpState;
                  prevState.mobileNo = e.target.value;
                  setSignUpState({ ...prevState });
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2" className="formLabel">
                Gender<span className="colorRed">*</span>
              </Typography>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${signUpState.genderName}`
                }}
                // value={selectGender}
                // onChange={(e) => setSelectGender(e.target.value)}
                value={signUpState.genderName}
                onChange={(e) => {
                  const prevState = signUpState;
                  prevState.genderName = e.target.value;
                  setSignUpState({ ...prevState });
                }}
              >
                <MenuItem value=" " disabled>
                  Select Gender
                </MenuItem>
                {signUpState.genderList.length > 0
                  ? signUpState.genderList.map((item, index) => (
                      <MenuItem key={index} value={item.typeId}>
                        {item.typeName}
                      </MenuItem>
                    ))
                  : ''}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2" className="formLabel">
                Age<span className="colorRed">*</span>
              </Typography>
              <TextField
                fullWidth
                inputProps={{ className: 'textInput' }}
                placeholder="Type Age"
                type="number"
                value={signUpState.age}
                onChange={(e) => {
                  const prevState = signUpState;
                  prevState.age = e.target.value;
                  setSignUpState({ ...prevState });
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="h6" className="formLabel">
                State<span className="colorRed">*</span>
              </Typography>
              <Autocomplete
                id="stateList"
                options={signUpState.stateList}
                size="small"
                onChange={(e, newValue) => {
                  const prevState = signUpState;
                  prevState.stateId = newValue;
                  prevState.cityId = null;

                  if (newValue) {
                    loantyprapiFire('cityList', newValue.stateId);
                  } else {
                    prevState.cityList = [];
                    prevState.cityId = null;
                  }

                  setSignUpState({ ...prevState });
                }}
                getOptionLabel={(option) =>
                  option.stateName ? option.stateName : signUpState.stateId.stateName
                }
                renderOption={(props, option) => <li {...props}>{option.stateName}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select State" />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="h6" className="formLabel">
                City<span className="colorRed">*</span>
              </Typography>
              <Autocomplete
                id="cityList"
                options={signUpState.cityList}
                size="small"
                value={signUpState.cityId !== null ? signUpState.cityId.cityName : null}
                onChange={(e, newValue) => {
                  const prevState = signUpState;
                  prevState.cityId = newValue;
                  setSignUpState({ ...prevState });
                }}
                getOptionLabel={(option) =>
                  option.cityName ? option.cityName : signUpState.cityId.cityName
                }
                renderOption={(props, option) => <li {...props}>{option.cityName}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select City" />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="body2" className="formLabel">
                Which of the following best describes you<span className="colorRed">*</span>
              </Typography>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${signUpState.describe}`
                }}
                // value={selectBestDescribes}
                // onChange={(e) => setSelectBestDescribes(e.target.value)}
                value={signUpState.describe}
                onChange={(e) => {
                  const prevState = signUpState;
                  prevState.describe = e.target.value;
                  setSignUpState({ ...prevState });
                }}
              >
                <MenuItem value=" " disabled>
                  Which of the following best describes you
                </MenuItem>
                {signUpState.describeList.length > 0
                  ? signUpState.describeList.map((item, index) => (
                      <MenuItem key={index} value={item.typeId}>
                        {item.typeName}
                      </MenuItem>
                    ))
                  : ''}
              </Select>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={12}>
                  <FormControl>
                    <Typography variant="body2" className="formLabel">
                      Which of the following best describes you
                    </Typography>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="female"
                      name="radio-buttons-group"
                      row
                    >
                      <FormControlLabel
                        value="Practising Financial Services/Insurance/Loan Agent"
                        control={<Radio />}
                        label="Practising Financial Services/Insurance/Loan Agent"
                      />
                      <FormControlLabel
                        value="Real Estate Broker/Professional"
                        control={<Radio />}
                        label="Real Estate Broker/Professional"
                      />
                      <FormControlLabel
                        value="Real Estate Developer"
                        control={<Radio />}
                        label="Real Estate Developer"
                      />
                      <FormControlLabel
                        value="Business Enthusiast/Freelancer"
                        control={<Radio />}
                        label="Business Enthusiast/Freelancer"
                      />
                      <FormControlLabel
                        value="Looking to startup/side hustle"
                        control={<Radio />}
                        label="Looking to startup/side hustle"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid> */}
          </Grid>
          <Box className="textAlignCenter">
            <Button
              className="mainBtn"
              onClick={(e) => {
                // setThankYouMsg(true);
                loantyprapiFire('submit', '');
              }}
            >
              Submit
            </Button>
          </Box>
          <Dialog
            fullWidth
            className="PopupBox"
            open={thankYouMsg}
            onClose={(e) => {
              setThankYouMsg(false);
            }}
          >
            <DialogTitle className="popupTitle">
              <Typography />
              <IconButton
                onClick={(e) => {
                  setThankYouMsg(false);
                  navigate('/');
                }}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              <Typography textAlign="center" className="mb-2">
                <BsEmojiSmile fontSize={50} color="#a6ce39" />
              </Typography>
              <Typography variant="subtitle1" textAlign="center">
                Thank You
              </Typography>
              <Typography variant="subtitle1" textAlign="center" mb={2}>
                For Your Interest !!
              </Typography>
              <Typography variant="subtitle2" textAlign="center" mb={2}>
                Our team will connect with you soon.
              </Typography>
            </DialogContent>
          </Dialog>
        </Box>

        <ApiErrorMessage
          openApiError={openApiError}
          setOpenApiError={setOpenApiError}
          errorMessage={errorMessage}
        />
      </Container>
    </Box>
  );
}

export default SignUpNew;
// Top Cities
